var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{staticClass:"img-fluid d-block w-100",attrs:{"src":_vm.logo}})])
}
var staticRenderFns = []

export { render, staticRenderFns }